export default __webpack_public_path__ + "static/media/github.7c542b6a.svg";